<template>
    <div v-if="appParams && appParams.staticTranslations">
        <hero-cards :cards="heroCards"></hero-cards>

        <section id="itb-beware-of-fakes">
            <div class="container">
                <div
                    id="itb-beware-of-fakes-bubble-left"
                    v-lazy:background-image="
                        '/images/' +
                        languageDependantImageSubFolder +
                        '/service-beware-bubble-left.webp'
                    "
                ></div>
                <div
                    id="itb-beware-of-fakes-bubble-middle"
                    v-lazy:background-image="
                        '/images/articles/home-benefits-bubble-middle.webp'
                    "
                ></div>
                <div
                    id="itb-beware-of-fakes-bubble-right"
                    v-lazy:background-image="
                        '/images/' +
                        languageDependantImageSubFolder +
                        '/home-benefits-bubble-right.webp'
                    "
                ></div>
                <div class="row">
                    <div class="col-12 col-md-6 itb-left-box">
                        <div
                            class="itb-top-image"
                            v-lazy:background-image="
                                '/images/articles/beware-of-fakes-left-top.webp'
                            "
                        ></div>
                        <div class="itb-middle-text itb-bg-red">
                            <h2>
                                {{
                                    appParams.staticTranslations[
                                        "our_service.beware_of_fakes_title_left"
                                    ]
                                }}
                            </h2>
                            <p class="m-0">
                                {{
                                    appParams.staticTranslations[
                                        "our_service.beware_of_fakes_text_left"
                                    ]
                                }}
                            </p>
                        </div>
                        <div
                            class="itb-bottom-image"
                            v-lazy:background-image="
                                '/images/articles/beware-of-fakes-left-bottom.webp'
                            "
                        ></div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-top-image"
                            v-lazy:background-image="
                                '/images/articles/beware-of-fakes-right-top.webp'
                            "
                        ></div>
                        <div class="itb-middle-text itb-bg-orange">
                            <h2>
                                {{
                                    appParams.staticTranslations[
                                        "our_service.beware_of_fakes_title_right"
                                    ]
                                }}
                            </h2>
                            <p class="m-0">
                                {{
                                    appParams.staticTranslations[
                                        "our_service.beware_of_fakes_text_right"
                                    ]
                                }}
                            </p>
                        </div>
                        <div
                            class="itb-bottom-image"
                            v-lazy:background-image="
                                '/images/articles/beware-of-fakes-right-bottom.webp'
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            heroCards: [],
            pageParams: [],
        };
    },

    mounted() {
        axios
            .get("/getOurServicePage")
            .then((response) => {
                this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;

                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({ appParams: "getAppParams" }),

        languageDependantImageSubFolder() {
            var folder = "articles";
            if (this.$store.state.domainLanguage != "en") {
                folder = "articles_" + this.$store.state.domainLanguage;
            }
            return folder;
        },
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),
    },
};
</script>
